// 在Header组件内添加状态管理
import React, {useEffect, useState} from "react";
import {GlobalRouterPath, Menus} from "../../constants";
import "./DesktopDropdown.css";


// 桌面端下拉菜单组件
export const DesktopDropdown = () => {
    const dropDownMenuRef = React.createRef<HTMLLIElement>();
    const [activeMenu, setActiveMenu] = useState<string | null>(null);// 哪个menu是active
    const [isHoveringPanel, setIsHoveringPanel] = useState(false);// 是否hover了一个菜单面板

    const [shouldAnimateOut, setShouldAnimateOut] = useState(false);// 鼠标离开面板时,面板动画是否显示

    const leaveTimerRef = React.createRef<NodeJS.Timeout>();// 离开父menu时


    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (dropDownMenuRef.current && !dropDownMenuRef.current.contains(e.target as Node)) {
                setActiveMenu(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <ul className="flex items-baseline space-x-2" role="list">
            {Menus.map((menu) => (
                <li
                    ref={dropDownMenuRef}
                    className="flex items-center justify-content:center hover:text-[#e91e63]"
                    onClick={() => {
                        if (!menu.children) return;
                        if (activeMenu === menu.text)
                            setActiveMenu(null);
                        else setActiveMenu(menu.text);
                    }}
                    onMouseEnter={() => setActiveMenu(menu.text)}
                    onMouseLeave={() => {
                        leaveTimerRef.current = setTimeout(() => {
                            if (!isHoveringPanel && !shouldAnimateOut) setActiveMenu(null);
                        }, 200);
                    }}
                >
                    <a href={menu.href}>
                        <div
                            className="px-2 py-1 rounded-md text-sm font-medium cursor-pointer hover:bg-gradient-to-r from-[#E65F50] to-[#FF6F61] transition-colors"
                        >
                            {menu.text}
                            {menu.children && <span className="ml-1">▾</span>}
                        </div>
                    </a>
                    {menu.children && activeMenu === menu.text &&
                        <div
                            className={`
                            ${shouldAnimateOut ? "opacity-0 translate-y-2" : "opacity-100 translate-y-0"} 
                                transition-all duration-300 ease-out
                                absolute max-w-[100vw] top-[93%] mt-1 w-[50vw] bg-gradient-to-r from-[#6366f1]/90 to-[#FF8A3D]/90 rounded-xl shadow-2xl z-2050 p-3
                                dropdown-panel
                            `}
                            onMouseEnter={() => {
                                if (leaveTimerRef.current) clearTimeout(leaveTimerRef.current);
                                setIsHoveringPanel(true);
                                setShouldAnimateOut(false);// 取消退出动画
                            }}
                            onMouseLeave={() => {
                                setShouldAnimateOut(true);// 开启退出动画
                                setTimeout(() => {
                                    setIsHoveringPanel(false);
                                    setActiveMenu(null);
                                    setShouldAnimateOut(false);// 取消退出动画
                                }, 300); // 与CSS动画时间一致
                            }}
                        >
                            {/* 标题 */}
                            <div className="mb-3 px-2">
                                <h3 className="text-lg font-semibold text-white">{menu.text}</h3>
                            </div>

                            {/* 流式网格布局 */}
                            <div className="grid grid-cols-3 gap-1">
                                {menu.children.map(child => (
                                    <a
                                        key={child.href}
                                        href={child.href}
                                        className="i-child-menu flex items-start items-center rounded-2xl hover:bg-black/10 transition-all"
                                    >
                                        {child.icon && (
                                            <div className="p-1 bg-white-8/50 rounded-2xl">
                                                <img src={child.icon} className="w-[13vw] h-[12vh] rounded-2xl text-purple-300 child-icon"/>
                                            </div>
                                        )}
                                        <div className="py-1 space-y-3 child-desc">
                                            <span className="text-lg font-medium text-white group-hover:text-purple-200">
                                              {child.text}
                                            </span>
                                            {child.desc && (
                                                <p className="text-xs text-gray-400 mt-1">{child.desc}</p>
                                            )}
                                        </div>
                                    </a>
                                ))}
                            </div>

                            {/* 底部操作区 */}
                            {menu.footer && (
                                <div className="mt-4 pt-3 border-purple-800/50">
                                    <div className="flex justify-center space-x-2">
                                        {menu.footer.actions.map(action => (
                                            <a
                                                key={action.text}
                                                href={action.href}
                                                className="text-sm text-purple-300 hover:text-white px-3 py-1.5 rounded-md hover:bg-purple-900/40 transition-colors"
                                            >
                                                {action.text}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </li>
            ))}
        </ul>
    );
};
